/* eslint-disable */
export const dummyData = {
    "status": "Success",
    "statusCode": 200,
    "message": "Success",
    "data": {
        "columns": [
            {
                "key": "Product Name",
                "label": "PRODUCT NAME",
                "fixed": true,
                "sortable": true,
                "dataType": "string",
                "sortKey": "value"
            },
            {
                "key": "Average Rate",
                "label": "AVERAGE RATE",
                "sortable": true,
                "dataType": "string",
                "sortKey": "rateComparison"
            },
            {
                "key": "PANOTTA_SECTION_GF",
                "label": "PANOTTA SECTION (GROUND FLOOR)",
                "sortable": true,
                "dataType": "string",
                "sortKey": "rateComparison",
                "data": [
                    {
                        "label": "Total",
                        "value": "0/53780 PCS -- 0.000/7,903.040 KG"
                    }
                ]
            },
            {
                "key": "VEG_SECTION_CUTTING_GF",
                "label": "VEG SECTION(CUTTING) (GROUND FLOOR)",
                "sortable": true,
                "dataType": "string",
                "sortKey": "rateComparison",
                "data": [
                    {
                        "label": "Total",
                        "value": "0.000/14.400 KG"
                    }
                ]
            },
            {
                "key": "HOT_KITCHEN_GF",
                "label": "HOT KITCHEN (GROUND FLOOR)",
                "sortable": true,
                "dataType": "string",
                "sortKey": "rateComparison",
                "data": [
                    {
                        "label": "Total",
                        "value": "0/53780 PCS -- 0.000/2,788.840 KG"
                    }
                ]
            },
            {
                "key": "Total",
                "label": "TOTAL",
                "sortable": true,
                "dataType": "string",
                "sortKey": "totalRateComparison",
                "data": [
                    {
                        "label": "Total",
                        "value": "0/107560 PCS -- 0.000/10,706.280 KG"
                    }
                ]
            }
        ],
        "data": [
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Taco Flaky wrap_Baking (+)",
                    "link": null,
                    "category": "Baking"
                },
                "Average Rate": {
                    "value": "₹0/kg vs ₹123/kg",
                    "currentRate": 0,
                    "idealRate": 123,
                    "unit": "kg",
                    "rateComparison": 0,
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹123/kg"
                    }
                },
                "PANOTTA_SECTION_GF": {
                    "value": "₹0/kg vs ₹123/kg",
                    "currentRate": 0,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/53780 PCS",
                    "weight": "0.000/7,903.040 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹123/kg"
                    }
                },
                "VEG_SECTION_CUTTING_GF": {
                    "value": "₹0/kg vs ₹123/kg",
                    "currentRate": 0,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "N/A",
                    "weight": "0.000/14.400 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹123/kg"
                    }
                },
                "HOT_KITCHEN_GF": {
                    "value": "₹0/kg vs ₹123/kg",
                    "currentRate": 0,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/53780 PCS",
                    "weight": "0.000/2,788.840 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹123/kg"
                    }
                },
                "Total": {
                    "value": "₹0/kg vs ₹123/kg",
                    "currentRate": 0,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/107560 PCS",
                    "weight": "0.000/10,706.280 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹123/kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Green Chillies_crushed (-)",
                    "link": null,
                    "category": "Vegetable"
                },
                "Average Rate": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "rateComparison": 220,
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "PANOTTA_SECTION_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "VEG_SECTION_CUTTING_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "N/A",
                    "weight": "0.000/14.400 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "HOT_KITCHEN_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "Total": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/14.400 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Spinach Medu Vada Veg Cutting - 30g - SFG (-)",
                    "link": null,
                    "category": "Snacks"
                },
                "Average Rate": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "rateComparison": 220,
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "PANOTTA_SECTION_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "VEG_SECTION_CUTTING_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "N/A",
                    "weight": "0.000/14.400 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "HOT_KITCHEN_GF": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                },
                "Total": {
                    "value": "₹220/kg vs ₹123/kg",
                    "currentRate": 220,
                    "idealRate": 123,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/14.400 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹220/kg vs ₹123/kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Paneer Butter Masala (+)",
                    "link": null,
                    "category": "Main Course"
                },
                "Average Rate": {
                    "value": "₹180/kg vs ₹150/kg",
                    "currentRate": 180,
                    "idealRate": 150,
                    "unit": "kg",
                    "rateComparison": 180,
                    "extra": {
                        "color": "green",
                        "subText": "₹180/kg vs ₹150/kg"
                    }
                },
                "PANOTTA_SECTION_GF": {
                    "value": "₹180/kg vs ₹150/kg",
                    "currentRate": 180,
                    "idealRate": 150,
                    "unit": "kg",
                    "quantity": "0/0 PCS",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹180/kg vs ₹150/kg"
                    }
                },
                "VEG_SECTION_CUTTING_GF": {
                    "value": "₹0/kg vs ₹150/kg",
                    "currentRate": 0,
                    "idealRate": 150,
                    "unit": "kg",
                    "quantity": "N/A",
                    "weight": "0.000/0.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹0/kg vs ₹150/kg"
                    }
                },
                "HOT_KITCHEN_GF": {
                    "value": "₹180/kg vs ₹150/kg",
                    "currentRate": 180,
                    "idealRate": 150,
                    "unit": "kg",
                    "quantity": "250/300 PCS",
                    "weight": "75.000/90.000 KG",
                    "extra": {
                        "color": "yellow",
                        "subText": "₹180/kg vs ₹150/kg"
                    }
                },
                "Total": {
                    "value": "₹180/kg vs ₹150/kg",
                    "currentRate": 180,
                    "idealRate": 150,
                    "unit": "kg",
                    "quantity": "250/300 PCS",
                    "weight": "75.000/90.000 KG",
                    "extra": {
                        "color": "green",
                        "subText": "₹180/kg vs ₹150/kg"
                    }
                }
            }
        ]
    }
};

export const dummyDispatchData = {
    "status": "Success",
    "statusCode": 200,
    "message": "Success",
    "data": {
        "columns": [
            {
                "key": "Product Name",
                "label": "Product Name",
                "fixed": true,
                "sortable": true,
                "dataType": "string",
                "sortKey": "value"
            },
            {
                "key": "Total",
                "label": "Total",
                "data": [
                    {
                        "label": "Total",
                        "value": "3150.75/3025.0"
                    }
                ]
            },
            {
                "key": "NORTH_MALL",
                "label": "North City Mall",
                "link": "/console2/analytics/inventory/new/list/po?paramNavSelected=true&store=%7B%22id%22%3A%201001%2C%20%22name%22%3A%20%22NORTH_MALL%22%7D&deliverFrom=%7B%22id%22%3A%201000%2C%20%22name%22%3A%20%22%22%7D&dateRange=%7B%22active%22%3A%20true%2C%20%22from%22%3A%20%222026-01-10%22%2C%20%22to%22%3A%20%222026-01-10%22%7D&timeType=%7B%22value%22%3A%20%22invoiced%22%2C%20%22label%22%3A%20%22Invoice%20Date%22%2C%20%22disabledFutureDate%22%3A%20false%7D",
                "poIds": "376001,376002",
                "sortable": true,
                "dataType": "string",
                "sortKey": "dispatchedQuantity",
                "data": [
                    {
                        "label": "Total",
                        "value": "750.25/720.0 Kg"
                    }
                ]
            },
            {
                "key": "SOUTH_OUTLET",
                "label": "South Side Outlet",
                "link": "/console2/analytics/inventory/new/list/po?paramNavSelected=true&store=%7B%22id%22%3A%201002%2C%20%22name%22%3A%20%22SOUTH_OUTLET%22%7D&deliverFrom=%7B%22id%22%3A%201000%2C%20%22name%22%3A%20%22%22%7D&dateRange=%7B%22active%22%3A%20true%2C%20%22from%22%3A%20%222026-01-10%22%2C%20%22to%22%3A%20%222026-01-10%22%7D&timeType=%7B%22value%22%3A%20%22invoiced%22%2C%20%22label%22%3A%20%22Invoice%20Date%22%2C%20%22disabledFutureDate%22%3A%20false%7D",
                "poIds": "376003,376004",
                "sortable": true,
                "dataType": "string",
                "sortKey": "dispatchedQuantity",
                "data": [
                    {
                        "label": "Total",
                        "value": "480.50/460.0 Kg"
                    }
                ]
            },
            {
                "key": "EAST_STORE",
                "label": "East End Store",
                "link": "/console2/analytics/inventory/new/list/po?paramNavSelected=true&store=%7B%22id%22%3A%201003%2C%20%22name%22%3A%20%22EAST_STORE%22%7D&deliverFrom=%7B%22id%22%3A%201000%2C%20%22name%22%3A%20%22%22%7D&dateRange=%7B%22active%22%3A%20true%2C%20%22from%22%3A%20%222026-01-10%22%2C%20%22to%22%3A%20%222026-01-10%22%7D&timeType=%7B%22value%22%3A%20%22invoiced%22%2C%20%22label%22%3A%20%22Invoice%20Date%22%2C%20%22disabledFutureDate%22%3A%20false%7D",
                "poIds": "376005,376006",
                "sortable": true,
                "dataType": "string",
                "sortKey": "dispatchedQuantity",
                "data": [
                    {
                        "label": "Total",
                        "value": "620.0/600.0 Kg"
                    }
                ]
            },
            {
                "key": "WEST_MART",
                "label": "Westside Mart",
                "link": "/console2/analytics/inventory/new/list/po?paramNavSelected=true&store=%7B%22id%22%3A%201004%2C%20%22name%22%3A%20%22WEST_MART%22%7D&deliverFrom=%7B%22id%22%3A%201000%2C%20%22name%22%3A%20%22%22%7D&dateRange=%7B%22active%22%3A%20true%2C%20%22from%22%3A%20%222026-01-10%22%2C%20%22to%22%3A%20%222026-01-10%22%7D&timeType=%7B%22value%22%3A%20%22invoiced%22%2C%20%22label%22%3A%20%22Invoice%20Date%22%2C%20%22disabledFutureDate%22%3A%20false%7D",
                "poIds": "376007,376008",
                "sortable": true,
                "dataType": "string",
                "sortKey": "dispatchedQuantity",
                "data": [
                    {
                        "label": "Total",
                        "value": "530.75/510.0 Kg"
                    }
                ]
            },
            {
                "key": "CENTRAL_HUB",
                "label": "Central Hub Store",
                "link": "/console2/analytics/inventory/new/list/po?paramNavSelected=true&store=%7B%22id%22%3A%201005%2C%20%22name%22%3A%20%22CENTRAL_HUB%22%7D&deliverFrom=%7B%22id%22%3A%201000%2C%20%22name%22%3A%20%22%22%7D&dateRange=%7B%22active%22%3A%20true%2C%20%22from%22%3A%20%222026-01-10%22%2C%20%22to%22%3A%20%222026-01-10%22%7D&timeType=%7B%22value%22%3A%20%22invoiced%22%2C%20%22label%22%3A%20%22Invoice%20Date%22%2C%20%22disabledFutureDate%22%3A%20false%7D",
                "poIds": "376009,376010",
                "sortable": true,
                "dataType": "string",
                "sortKey": "dispatchedQuantity",
                "data": [
                    {
                        "label": "Total",
                        "value": "769.25/735.0 Kg"
                    }
                ]
            }
        ],
        "data": [
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Premium Basmati Rice",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "150.5 Kg / 145.0 Kg",
                    "dispatchedQuantity": 150.5,
                    "orderedQuantity": 145.0,
                    "extra": {
                        "color": "red",
                        "subText": "150.5 Kg / 145.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "95.75 Kg / 90.0 Kg",
                    "dispatchedQuantity": 95.75,
                    "orderedQuantity": 90.0,
                    "extra": {
                        "color": "red",
                        "subText": "95.75 Kg / 90.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "125.0 Kg / 120.0 Kg",
                    "dispatchedQuantity": 125.0,
                    "orderedQuantity": 120.0,
                    "extra": {
                        "color": "red",
                        "subText": "125.0 Kg / 120.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "105.25 Kg / 100.0 Kg",
                    "dispatchedQuantity": 105.25,
                    "orderedQuantity": 100.0,
                    "extra": {
                        "color": "red",
                        "subText": "105.25 Kg / 100.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "155.5 Kg / 150.0 Kg",
                    "dispatchedQuantity": 155.5,
                    "orderedQuantity": 150.0,
                    "extra": {
                        "color": "red",
                        "subText": "155.5 Kg / 150.0 Kg"
                    }
                },
                "Total": {
                    "value": "632.0 Kg / 605.0 Kg",
                    "dispatchedQuantity": 632.0,
                    "orderedQuantity": 605.0,
                    "extra": {
                        "color": "red",
                        "subText": "632.0 Kg / 605.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Organic Wheat Flour",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "120.0 Kg / 115.0 Kg",
                    "dispatchedQuantity": 120.0,
                    "orderedQuantity": 115.0,
                    "extra": {
                        "color": "red",
                        "subText": "120.0 Kg / 115.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "85.5 Kg / 80.0 Kg",
                    "dispatchedQuantity": 85.5,
                    "orderedQuantity": 80.0,
                    "extra": {
                        "color": "red",
                        "subText": "85.5 Kg / 80.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "100.0 Kg / 95.0 Kg",
                    "dispatchedQuantity": 100.0,
                    "orderedQuantity": 95.0,
                    "extra": {
                        "color": "red",
                        "subText": "100.0 Kg / 95.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "90.0 Kg / 85.0 Kg",
                    "dispatchedQuantity": 90.0,
                    "orderedQuantity": 85.0,
                    "extra": {
                        "color": "red",
                        "subText": "90.0 Kg / 85.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "130.25 Kg / 125.0 Kg",
                    "dispatchedQuantity": 130.25,
                    "orderedQuantity": 125.0,
                    "extra": {
                        "color": "red",
                        "subText": "130.25 Kg / 125.0 Kg"
                    }
                },
                "Total": {
                    "value": "525.75 Kg / 500.0 Kg",
                    "dispatchedQuantity": 525.75,
                    "orderedQuantity": 500.0,
                    "extra": {
                        "color": "red",
                        "subText": "525.75 Kg / 500.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Virgin Coconut Oil",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "85.75 Kg / 80.0 Kg",
                    "dispatchedQuantity": 85.75,
                    "orderedQuantity": 80.0,
                    "extra": {
                        "color": "red",
                        "subText": "85.75 Kg / 80.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "65.25 Kg / 60.0 Kg",
                    "dispatchedQuantity": 65.25,
                    "orderedQuantity": 60.0,
                    "extra": {
                        "color": "red",
                        "subText": "65.25 Kg / 60.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "75.0 Kg / 70.0 Kg",
                    "dispatchedQuantity": 75.0,
                    "orderedQuantity": 70.0,
                    "extra": {
                        "color": "red",
                        "subText": "75.0 Kg / 70.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "70.5 Kg / 65.0 Kg",
                    "dispatchedQuantity": 70.5,
                    "orderedQuantity": 65.0,
                    "extra": {
                        "color": "red",
                        "subText": "70.5 Kg / 65.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "95.0 Kg / 90.0 Kg",
                    "dispatchedQuantity": 95.0,
                    "orderedQuantity": 90.0,
                    "extra": {
                        "color": "red",
                        "subText": "95.0 Kg / 90.0 Kg"
                    }
                },
                "Total": {
                    "value": "391.5 Kg / 365.0 Kg",
                    "dispatchedQuantity": 391.5,
                    "orderedQuantity": 365.0,
                    "extra": {
                        "color": "red",
                        "subText": "391.5 Kg / 365.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Organic Jaggery",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "95.0 Kg / 90.0 Kg",
                    "dispatchedQuantity": 95.0,
                    "orderedQuantity": 90.0,
                    "extra": {
                        "color": "red",
                        "subText": "95.0 Kg / 90.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "72.5 Kg / 70.0 Kg",
                    "dispatchedQuantity": 72.5,
                    "orderedQuantity": 70.0,
                    "extra": {
                        "color": "red",
                        "subText": "72.5 Kg / 70.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "85.0 Kg / 80.0 Kg",
                    "dispatchedQuantity": 85.0,
                    "orderedQuantity": 80.0,
                    "extra": {
                        "color": "red",
                        "subText": "85.0 Kg / 80.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "78.25 Kg / 75.0 Kg",
                    "dispatchedQuantity": 78.25,
                    "orderedQuantity": 75.0,
                    "extra": {
                        "color": "red",
                        "subText": "78.25 Kg / 75.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "105.5 Kg / 100.0 Kg",
                    "dispatchedQuantity": 105.5,
                    "orderedQuantity": 100.0,
                    "extra": {
                        "color": "red",
                        "subText": "105.5 Kg / 100.0 Kg"
                    }
                },
                "Total": {
                    "value": "436.25 Kg / 415.0 Kg",
                    "dispatchedQuantity": 436.25,
                    "orderedQuantity": 415.0,
                    "extra": {
                        "color": "red",
                        "subText": "436.25 Kg / 415.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Masala Spice Mix",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "75.0 Kg / 70.0 Kg",
                    "dispatchedQuantity": 75.0,
                    "orderedQuantity": 70.0,
                    "extra": {
                        "color": "red",
                        "subText": "75.0 Kg / 70.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "52.5 Kg / 50.0 Kg",
                    "dispatchedQuantity": 52.5,
                    "orderedQuantity": 50.0,
                    "extra": {
                        "color": "red",
                        "subText": "52.5 Kg / 50.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "60.0 Kg / 55.0 Kg",
                    "dispatchedQuantity": 60.0,
                    "orderedQuantity": 55.0,
                    "extra": {
                        "color": "red",
                        "subText": "60.0 Kg / 55.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "55.75 Kg / 50.0 Kg",
                    "dispatchedQuantity": 55.75,
                    "orderedQuantity": 50.0,
                    "extra": {
                        "color": "red",
                        "subText": "55.75 Kg / 50.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "82.5 Kg / 75.0 Kg",
                    "dispatchedQuantity": 82.5,
                    "orderedQuantity": 75.0,
                    "extra": {
                        "color": "red",
                        "subText": "82.5 Kg / 75.0 Kg"
                    }
                },
                "Total": {
                    "value": "325.75 Kg / 300.0 Kg",
                    "dispatchedQuantity": 325.75,
                    "orderedQuantity": 300.0,
                    "extra": {
                        "color": "red",
                        "subText": "325.75 Kg / 300.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Dry Fruits Combo",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "60.0 Kg / 55.0 Kg",
                    "dispatchedQuantity": 60.0,
                    "orderedQuantity": 55.0,
                    "extra": {
                        "color": "red",
                        "subText": "60.0 Kg / 55.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "45.0 Kg / 40.0 Kg",
                    "dispatchedQuantity": 45.0,
                    "orderedQuantity": 40.0,
                    "extra": {
                        "color": "red",
                        "subText": "45.0 Kg / 40.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "50.0 Kg / 45.0 Kg",
                    "dispatchedQuantity": 50.0,
                    "orderedQuantity": 45.0,
                    "extra": {
                        "color": "red",
                        "subText": "50.0 Kg / 45.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "47.5 Kg / 42.0 Kg",
                    "dispatchedQuantity": 47.5,
                    "orderedQuantity": 42.0,
                    "extra": {
                        "color": "red",
                        "subText": "47.5 Kg / 42.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "65.5 Kg / 60.0 Kg",
                    "dispatchedQuantity": 65.5,
                    "orderedQuantity": 60.0,
                    "extra": {
                        "color": "red",
                        "subText": "65.5 Kg / 60.0 Kg"
                    }
                },
                "Total": {
                    "value": "268.0 Kg / 242.0 Kg",
                    "dispatchedQuantity": 268.0,
                    "orderedQuantity": 242.0,
                    "extra": {
                        "color": "red",
                        "subText": "268.0 Kg / 242.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Herbal Tea Leaves",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "55.0 Kg / 50.0 Kg",
                    "dispatchedQuantity": 55.0,
                    "orderedQuantity": 50.0,
                    "extra": {
                        "color": "red",
                        "subText": "55.0 Kg / 50.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "38.5 Kg / 35.0 Kg",
                    "dispatchedQuantity": 38.5,
                    "orderedQuantity": 35.0,
                    "extra": {
                        "color": "red",
                        "subText": "38.5 Kg / 35.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "45.0 Kg / 40.0 Kg",
                    "dispatchedQuantity": 45.0,
                    "orderedQuantity": 40.0,
                    "extra": {
                        "color": "red",
                        "subText": "45.0 Kg / 40.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "42.25 Kg / 38.0 Kg",
                    "dispatchedQuantity": 42.25,
                    "orderedQuantity": 38.0,
                    "extra": {
                        "color": "red",
                        "subText": "42.25 Kg / 38.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "58.0 Kg / 53.0 Kg",
                    "dispatchedQuantity": 58.0,
                    "orderedQuantity": 53.0,
                    "extra": {
                        "color": "red",
                        "subText": "58.0 Kg / 53.0 Kg"
                    }
                },
                "Total": {
                    "value": "238.75 Kg / 216.0 Kg",
                    "dispatchedQuantity": 238.75,
                    "orderedQuantity": 216.0,
                    "extra": {
                        "color": "red",
                        "subText": "238.75 Kg / 216.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Honey Blend",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "65.0 Kg / 60.0 Kg",
                    "dispatchedQuantity": 65.0,
                    "orderedQuantity": 60.0,
                    "extra": {
                        "color": "red",
                        "subText": "65.0 Kg / 60.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "49.0 Kg / 45.0 Kg",
                    "dispatchedQuantity": 49.0,
                    "orderedQuantity": 45.0,
                    "extra": {
                        "color": "red",
                        "subText": "49.0 Kg / 45.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "55.0 Kg / 50.0 Kg",
                    "dispatchedQuantity": 55.0,
                    "orderedQuantity": 50.0,
                    "extra": {
                        "color": "red",
                        "subText": "55.0 Kg / 50.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "52.5 Kg / 47.0 Kg",
                    "dispatchedQuantity": 52.5,
                    "orderedQuantity": 47.0,
                    "extra": {
                        "color": "red",
                        "subText": "52.5 Kg / 47.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "70.0 Kg / 65.0 Kg",
                    "dispatchedQuantity": 70.0,
                    "orderedQuantity": 65.0,
                    "extra": {
                        "color": "red",
                        "subText": "70.0 Kg / 65.0 Kg"
                    }
                },
                "Total": {
                    "value": "291.5 Kg / 267.0 Kg",
                    "dispatchedQuantity": 291.5,
                    "orderedQuantity": 267.0,
                    "extra": {
                        "color": "red",
                        "subText": "291.5 Kg / 267.0 Kg"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Coffee Powder",
                    "link": null
                },
                "NORTH_MALL": {
                    "value": "44.0 Kg / 40.0 Kg",
                    "dispatchedQuantity": 44.0,
                    "orderedQuantity": 40.0,
                    "extra": {
                        "color": "red",
                        "subText": "44.0 Kg / 40.0 Kg"
                    }
                },
                "SOUTH_OUTLET": {
                    "value": "35.0 Kg / 30.0 Kg",
                    "dispatchedQuantity": 35.0,
                    "orderedQuantity": 30.0,
                    "extra": {
                        "color": "red",
                        "subText": "35.0 Kg / 30.0 Kg"
                    }
                },
                "EAST_STORE": {
                    "value": "40.0 Kg / 35.0 Kg",
                    "dispatchedQuantity": 40.0,
                    "orderedQuantity": 35.0,
                    "extra": {
                        "color": "red",
                        "subText": "40.0 Kg / 35.0 Kg"
                    }
                },
                "WEST_MART": {
                    "value": "38.0 Kg / 33.0 Kg",
                    "dispatchedQuantity": 38.0,
                    "orderedQuantity": 33.0,
                    "extra": {
                        "color": "red",
                        "subText": "38.0 Kg / 33.0 Kg"
                    }
                },
                "CENTRAL_HUB": {
                    "value": "52.0 Kg / 47.0 Kg",
                    "dispatchedQuantity": 52.0,
                    "orderedQuantity": 47.0,
                    "extra": {
                        "color": "red",
                        "subText": "52.0 Kg / 47.0 Kg"
                    }
                },
                "Total": {
                    "value": "209.0 Kg / 185.0 Kg",
                    "dispatchedQuantity": 209.0,
                    "orderedQuantity": 185.0,
                    "extra": {
                        "color": "red",
                        "subText": "209.0 Kg / 185.0 Kg"
                    }
                }
            }
        ]
    }
}

export const dummySecondaryPackagingData = {
    "status": "Success",
    "statusCode": 200,
    "message": "Success",
    "data": {
        "columns": [
            {
                "key": "Product Name",
                "label": "Product Name",
                "fixed": true,
                "sortable": true,
                "dataType": "string",
                "sortKey": "value"
            },
            {
                "key": "Total",
                "label": "Total",
                "data": [
                    {
                        "label": "Total",
                        "value": "15250/15000 Packs"
                    }
                ]
            },
            {
                "key": "PACKAGING_LINE_1",
                "label": "Packaging Line 1",
                "sortable": true,
                "dataType": "string",
                "sortKey": "scannedPacks",
                "data": [
                    {
                        "label": "Total",
                        "value": "5250/5000 Packs"
                    }
                ]
            },
            {
                "key": "PACKAGING_LINE_2",
                "label": "Packaging Line 2",
                "sortable": true,
                "dataType": "string",
                "sortKey": "scannedPacks",
                "data": [
                    {
                        "label": "Total",
                        "value": "5100/5000 Packs"
                    }
                ]
            },
            {
                "key": "PACKAGING_LINE_3",
                "label": "Packaging Line 3",
                "sortable": true,
                "dataType": "string",
                "sortKey": "scannedPacks",
                "data": [
                    {
                        "label": "Total",
                        "value": "4900/5000 Packs"
                    }
                ]
            }
        ],
        "data": [
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Basmati Rice 5kg",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "550/500 Packs",
                    "scannedPacks": 550,
                    "orderedPacks": 500,
                    "packSize": 5,
                    "pricePerPiece": 850,
                    "extra": {
                        "color": "red",
                        "subText": "550 Packs / 500 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "520/500 Packs",
                    "scannedPacks": 520,
                    "orderedPacks": 500,
                    "packSize": 5,
                    "pricePerPiece": 850,
                    "extra": {
                        "color": "red",
                        "subText": "520 Packs / 500 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "480/500 Packs",
                    "scannedPacks": 480,
                    "orderedPacks": 500,
                    "packSize": 5,
                    "pricePerPiece": 850,
                    "extra": {
                        "color": "green",
                        "subText": "480 Packs / 500 Packs"
                    }
                },
                "Total": {
                    "value": "1550/1500 Packs",
                    "scannedPacks": 1550,
                    "orderedPacks": 1500,
                    "packSize": 5,
                    "pricePerPiece": 850,
                    "extra": {
                        "color": "red",
                        "subText": "1550 Packs / 1500 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Wheat Flour 2kg",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "750/700 Packs",
                    "scannedPacks": 750,
                    "orderedPacks": 700,
                    "packSize": 2,
                    "pricePerPiece": 280,
                    "extra": {
                        "color": "red",
                        "subText": "750 Packs / 700 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "720/700 Packs",
                    "scannedPacks": 720,
                    "orderedPacks": 700,
                    "packSize": 2,
                    "pricePerPiece": 280,
                    "extra": {
                        "color": "red",
                        "subText": "720 Packs / 700 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "680/700 Packs",
                    "scannedPacks": 680,
                    "orderedPacks": 700,
                    "packSize": 2,
                    "pricePerPiece": 280,
                    "extra": {
                        "color": "green",
                        "subText": "680 Packs / 700 Packs"
                    }
                },
                "Total": {
                    "value": "2150/2100 Packs",
                    "scannedPacks": 2150,
                    "orderedPacks": 2100,
                    "packSize": 2,
                    "pricePerPiece": 280,
                    "extra": {
                        "color": "red",
                        "subText": "2150 Packs / 2100 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Sugar 1kg",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "1200/1100 Packs",
                    "scannedPacks": 1200,
                    "orderedPacks": 1100,
                    "packSize": 1,
                    "pricePerPiece": 45,
                    "extra": {
                        "color": "red",
                        "subText": "1200 Packs / 1100 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "1150/1100 Packs",
                    "scannedPacks": 1150,
                    "orderedPacks": 1100,
                    "packSize": 1,
                    "pricePerPiece": 45,
                    "extra": {
                        "color": "red",
                        "subText": "1150 Packs / 1100 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "1050/1100 Packs",
                    "scannedPacks": 1050,
                    "orderedPacks": 1100,
                    "packSize": 1,
                    "pricePerPiece": 45,
                    "extra": {
                        "color": "green",
                        "subText": "1050 Packs / 1100 Packs"
                    }
                },
                "Total": {
                    "value": "3400/3300 Packs",
                    "scannedPacks": 3400,
                    "orderedPacks": 3300,
                    "packSize": 1,
                    "pricePerPiece": 45,
                    "extra": {
                        "color": "red",
                        "subText": "3400 Packs / 3300 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Lentils 500g",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "800/750 Packs",
                    "scannedPacks": 800,
                    "orderedPacks": 750,
                    "packSize": 0.5,
                    "pricePerPiece": 60,
                    "extra": {
                        "color": "red",
                        "subText": "800 Packs / 750 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "780/750 Packs",
                    "scannedPacks": 780,
                    "orderedPacks": 750,
                    "packSize": 0.5,
                    "pricePerPiece": 60,
                    "extra": {
                        "color": "red",
                        "subText": "780 Packs / 750 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "740/750 Packs",
                    "scannedPacks": 740,
                    "orderedPacks": 750,
                    "packSize": 0.5,
                    "pricePerPiece": 60,
                    "extra": {
                        "color": "green",
                        "subText": "740 Packs / 750 Packs"
                    }
                },
                "Total": {
                    "value": "2320/2250 Packs",
                    "scannedPacks": 2320,
                    "orderedPacks": 2250,
                    "packSize": 0.5,
                    "pricePerPiece": 60,
                    "extra": {
                        "color": "red",
                        "subText": "2320 Packs / 2250 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Tea 250g",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "950/900 Packs",
                    "scannedPacks": 950,
                    "orderedPacks": 900,
                    "packSize": 0.25,
                    "pricePerPiece": 150,
                    "extra": {
                        "color": "red",
                        "subText": "950 Packs / 900 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "920/900 Packs",
                    "scannedPacks": 920,
                    "orderedPacks": 900,
                    "packSize": 0.25,
                    "pricePerPiece": 150,
                    "extra": {
                        "color": "red",
                        "subText": "920 Packs / 900 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "890/900 Packs",
                    "scannedPacks": 890,
                    "orderedPacks": 900,
                    "packSize": 0.25,
                    "pricePerPiece": 150,
                    "extra": {
                        "color": "green",
                        "subText": "890 Packs / 900 Packs"
                    }
                },
                "Total": {
                    "value": "2760/2700 Packs",
                    "scannedPacks": 2760,
                    "orderedPacks": 2700,
                    "packSize": 0.25,
                    "pricePerPiece": 150,
                    "extra": {
                        "color": "red",
                        "subText": "2760 Packs / 2700 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Coffee 200g",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "600/550 Packs",
                    "scannedPacks": 600,
                    "orderedPacks": 550,
                    "packSize": 0.2,
                    "pricePerPiece": 200,
                    "extra": {
                        "color": "red",
                        "subText": "600 Packs / 550 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "580/550 Packs",
                    "scannedPacks": 580,
                    "orderedPacks": 550,
                    "packSize": 0.2,
                    "pricePerPiece": 200,
                    "extra": {
                        "color": "red",
                        "subText": "580 Packs / 550 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "560/550 Packs",
                    "scannedPacks": 560,
                    "orderedPacks": 550,
                    "packSize": 0.2,
                    "pricePerPiece": 200,
                    "extra": {
                        "color": "red",
                        "subText": "560 Packs / 550 Packs"
                    }
                },
                "Total": {
                    "value": "1740/1650 Packs",
                    "scannedPacks": 1740,
                    "orderedPacks": 1650,
                    "packSize": 0.2,
                    "pricePerPiece": 200,
                    "extra": {
                        "color": "red",
                        "subText": "1740 Packs / 1650 Packs"
                    }
                }
            },
            {
                "isDummy": true,
                "Product Name": {
                    "value": "Spices 100g",
                    "link": null
                },
                "PACKAGING_LINE_1": {
                    "value": "400/350 Packs",
                    "scannedPacks": 400,
                    "orderedPacks": 350,
                    "packSize": 0.1,
                    "pricePerPiece": 50,
                    "extra": {
                        "color": "red",
                        "subText": "400 Packs / 350 Packs"
                    }
                },
                "PACKAGING_LINE_2": {
                    "value": "380/350 Packs",
                    "scannedPacks": 380,
                    "orderedPacks": 350,
                    "packSize": 0.1,
                    "pricePerPiece": 50,
                    "extra": {
                        "color": "red",
                        "subText": "380 Packs / 350 Packs"
                    }
                },
                "PACKAGING_LINE_3": {
                    "value": "350/350 Packs",
                    "scannedPacks": 350,
                    "orderedPacks": 350,
                    "packSize": 0.1,
                    "pricePerPiece": 50,
                    "extra": {
                        "color": "yellow",
                        "subText": "350 Packs / 350 Packs"
                    }
                },
                "Total": {
                    "value": "1130/1050 Packs",
                    "scannedPacks": 1130,
                    "orderedPacks": 1050,
                    "packSize": 0.1,
                    "pricePerPiece": 50,
                    "extra": {
                        "color": "red",
                        "subText": "1130 Packs / 1050 Packs"
                    }
                }
            }
        ]
    }
}